import { api } from '@/services'

type UpdateData = {
    password: string
    newPassword: string
    email: string
    clientId: string
}

async function useChangePassword(UpdateData: UpdateData) {
    var Response = null
    var Error = null
    var Loading = true

    const Controller = new AbortController()

    const MakeRequest = async () => {
        try {
            const resp = await api.post(
                `/Auth/ChangePassword?email=${UpdateData.email}&oldPassword=${UpdateData.password}&newPassword=${UpdateData.newPassword}&clientId=${UpdateData.clientId}`,
                null,
                {
                    signal: Controller.signal
                }
            )
            Response = resp.data
        } catch (error) {
            Error = error
        } finally {
            Loading = false
        }
    }

    await MakeRequest()

    Controller.abort()

    return [Response, Error, Loading]
}

export { useChangePassword }
